export const GET_PRODUCT_SUCCESS = "getProductSuccess";
export const GET_PRODUCT_FAIL = "getProductFail";
